// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PressContent__pressContainer___3oSf7{padding:0 24px 128px}.PressContent__inner___2E94Q{display:flex;flex-direction:column;align-items:center;padding-top:80px}@media (min-width:960px){.PressContent__inner___2E94Q{flex-direction:row;align-items:inherit;justify-content:space-between}}.PressContent__sidebar___1sP5B{flex-grow:1;min-width:0;max-width:620px}@media (min-width:960px){.PressContent__sidebar___1sP5B{min-width:300px;max-width:475px;margin-right:80px}}.PressContent__article___1Qy3N{flex-grow:1;max-width:620px;margin-top:80px}@media (min-width:960px){.PressContent__article___1Qy3N{margin-top:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"pressContainer": "PressContent__pressContainer___3oSf7",
	"inner": "PressContent__inner___2E94Q",
	"sidebar": "PressContent__sidebar___1sP5B",
	"article": "PressContent__article___1Qy3N"
};
module.exports = ___CSS_LOADER_EXPORT___;
